<template>
  <div
    :style="{ backgroundColor: hasBg ? bgColor : 'transparent' }"
    style=" border-radius: 4px;padding:4px 8px; text-align: center; "
  >
    <table width="100%" style="border-collapse: collapse;">
      <tr>
        <td :style="{ color: color }" style="padding-right:8px; text-align: center; font-size: 12px;font-weight: 500;">
          <template v-if="trend === 'up'">
            {{ $t('report.legendTrendUp') }}
          </template>
          <template v-else-if="trend === 'equal'">
            {{ $t('report.legendTrendEqual') }}
          </template>
          <template v-else-if="trend === 'down'">
            {{ $t('report.legendTrendDown') }}
          </template>
        </td>
        <td>
          <img
            src="https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/generic/trend-increase.png"
            :width="size"
            :height="size"
            v-if="trend === 'up'"
          />
          <img
            src="https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/generic/trend-equal.png"
            :width="size"
            :height="size"
            v-else-if="trend === 'equal'"
          />
          <img
            src="https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/generic/trend-decrease.png"
            :width="size"
            :height="size"
            v-else-if="trend === 'down'"
          />
          <img
            src="https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/generic/trend-warning.png"
            :width="size"
            :height="size"
            v-else-if="trend === 'warning'"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UiTrend',
  props: {
    trend: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '12',
    },
    hasBg: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    bgColor() {
      if (this.trend === 'up') {
        return 'rgba(5,147,71,.1)'
      } else if (this.trend === 'down') {
        return 'rgba(202,42,29,.1)'
      } else if (this.trend === 'equal') {
        return 'rgba(57,124,255,.1)'
      }
      return ''
    },
    color() {
      if (this.trend === 'up') {
        return 'rgba(5,147,71,1)'
      } else if (this.trend === 'down') {
        return 'rgba(202,42,29,1)'
      } else if (this.trend === 'equal') {
        return 'rgba(57,124,255,1)'
      }
      return ''
    },
  },
}
</script>
